<template>
  <div>
    <div class="container">
      <span class="title is-3">{{ empresa.nombrec }}</span>
      <small class="title is-5"
        >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
      >
      <small class="subtitle is-7">{{ empresa.nombre }}</small>
      <hr />
      <div class="buttons">
        <button class="button is-light" v-on:click="showForm('create')">
          <span class="icon is-small">
            <span class="material-icons">add_circle_outline</span>
          </span>
          <span>Crear</span>
        </button>
      </div>
      <div v-if="showListLineas">
        <h1 class="title">Líneas Contables</h1>
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Código</th>
              <th>Descripción</th>
              <th>Impuesto</th>
              <th>Cuenta Ingreso</th>
              <th>Inventario</th>
              <th>Cuenta Inventario</th>
              <th>Cuenta Costo</th>
              <th>Cuenta Impuesto</th>
              <th>% Impuesto</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(linea, index) in lineas" :key="index">
              <td>{{ linea.codigo }}</td>
              <td>{{ linea.descripcion }}</td>
              <td>{{ linea.impuesto ? "Si" : "No" }}</td>
              <td>
                <small class="fontMono">{{ linea.ctaIngreso.codigo }}</small>
                <small>{{ linea.ctaIngreso.nombre }}</small>
              </td>
              <td>{{ linea.inventario ? "Si" : "No" }}</td>
              <td>
                <small class="fontMono">{{
                  linea.ctaInventario && linea.inventario
                    ? linea.ctaInventario.codigo
                    : ""
                }}</small>
                <small>{{
                  linea.ctaInventario && linea.inventario
                    ? linea.ctaInventario.nombre
                    : ""
                }}</small>
              </td>
              <td>
                <small class="fontMono">{{
                  linea.ctaCosto && linea.inventario
                    ? linea.ctaCosto.codigo
                    : ""
                }}</small>
                <small>{{
                  linea.ctaCosto && linea.inventario
                    ? linea.ctaCosto.nombre
                    : ""
                }}</small>
              </td>
              <td>
                <small class="fontMono">{{
                  linea.ctaImpto && linea.impuesto ? linea.ctaImpto.codigo : ""
                }}</small>
                <small>{{
                  linea.ctaImpto && linea.impuesto ? linea.ctaImpto.nombre : ""
                }}</small>
              </td>
              <td>
                <span class="fontMono"
                  >{{
                    linea.vImpuesto && linea.impuesto ? linea.vImpuesto : 0
                  }}%</span
                >
              </td>
              <td>
                <span
                  class="icon has-text-info hand"
                  @click="selectLine(linea)"
                >
                  <i class="material-icons">edit</i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="showCreateLinea">
        <h1 class="title is-4">{{ titleform }}</h1>
        <div class="columns is-multiline">
          <div class="column is-4">
            <div class="field">
              <label class="label">Código</label>
              <div class="control is-expanded">
                <input
                  v-model="line.codigo"
                  class="input"
                  type="text"
                  placeholder="Código"
                />
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Descripción</label>
              <div class="control is-expanded">
                <input
                  v-model="line.descripcion"
                  class="input"
                  type="text"
                  placeholder="Descripción"
                />
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Tiene Impuesto</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.impuesto">
                    <option :value="true">Si</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Cuenta de Ingreso</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.ctaIngreso">
                    <option
                      v-for="(cuenta, index) in ctaIngreso"
                      :value="cuenta._id"
                      :key="index"
                    >
                      {{ cuenta.codigo }} {{ cuenta.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Mueve Inventario</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.inventario">
                    <option :value="true">Si</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4" v-show="line.impuesto">
            <div class="field">
              <label class="label">Cuenta de Impuesto</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.ctaImpto">
                    <option
                      v-for="(cuenta, index) in ctaImpto"
                      :value="cuenta._id"
                      :key="index"
                    >
                      {{ cuenta.codigo }} {{ cuenta.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4" v-show="line.impuesto">
            <div class="field">
              <label class="label">% Impuesto</label>
              <div class="control is-expanded">
                <input
                  v-model="line.vImpuesto"
                  class="input"
                  type="number"
                  placeholder="% de Impuesto"
                />
              </div>
            </div>
          </div>
          <div class="column is-4" v-show="line.inventario">
            <div class="field">
              <label class="label">Cuenta de Inventario</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.ctaInventario">
                    <option
                      v-for="(cuenta, index) in ctaInventario"
                      :value="cuenta._id"
                      :key="index"
                    >
                      {{ cuenta.codigo }} {{ cuenta.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4" v-show="line.inventario">
            <div class="field">
              <label class="label">Cuenta de Costo</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="line.ctaCosto">
                    <option
                      v-for="(cuenta, index) in ctaCosto"
                      :value="cuenta._id"
                      :key="index"
                    >
                      {{ cuenta.codigo }} {{ cuenta.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="button is-info" @click="saveLine">
            <span class="material-icons">save</span>Guardar
          </button>
          <button class="button" @click="showList()">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      lineas: [],
      showEditForm: false,
      showListLineas: true,
      showCreateLinea: false,
      titleform: "Crear Línea",
      line: {
        codigo: "",
        descripcion: "",
        impuesto1: "No",
        impuesto: false,
        ctaIngreso: "",
        inventario1: "No",
        inventario: false,
        ctaInventario: "",
        ctaCosto: "",
        ctaImpto: "",
        vImpuesto: "",
      },
      ctaIngreso: [],
      ctaInventario: [],
      ctaCosto: [],
      ctaImpto: [],
      error: null,
    };
  },
  computed: {
    ...mapState(["productos", "cuentas", "empresa"]),
  },
  methods: {
    async getLineas(_this) {
      try {
        let result;
        result = await apiServices.get(`/lineas`);
        _this.lineas = result.data;
        this.ctaIngreso = [];
        this.ctaInventario = [];
        this.ctaCosto = [];
        this.ctaImpto = [];
        this.cuentas.forEach((cuenta) => {
          if (cuenta.ingreso) {
            _this.ctaIngreso.push(cuenta);
          }
          if (cuenta.inventario) {
            _this.ctaInventario.push(cuenta);
          }
          if (cuenta.costoProd) {
            _this.ctaCosto.push(cuenta);
          }
          if (cuenta.base) {
            _this.ctaImpto.push(cuenta);
          }
        });
        this.ctaImpto = functions.order(this.ctaImpto, "codigo");
        this.ctaIngreso = functions.order(this.ctaIngreso, "codigo");
        this.costoProd = functions.order(this.costoProd, "codigo");
        this.ctaInventario = functions.order(this.ctaInventario, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    showForm(tipo) {
      if (tipo === "create") {
        this.titleform = "Crear Línea";
      } else {
        this.titleform = "Editar Línea";
      }
      this.showCreateLinea = true;
      this.showListLineas = false;
    },
    showList() {
      this.showListLineas = true;
      this.showCreateLinea = false;
      this.line = {
        codigo: "",
        descripcion: "",
        impuesto: false,
        ctaIngreso: "",
        inventario: false,
        ctaInventario: "",
        ctaCosto: "",
        ctaImpto: "",
        vImpuesto: "",
      };
      this.error = null;
    },
    selectLine(linea) {
      this.showForm();
      this.line._id = linea._id;
      this.line.codigo = linea.codigo;
      this.line.descripcion = linea.descripcion;
      this.line.impuesto = linea.impuesto;
      this.line.ctaIngreso = linea.ctaIngreso._id;
      this.line.inventario = linea.inventario;
      this.line.ctaInventario = linea.inventario ? linea.ctaInventario._id : "";
      this.line.ctaCosto = linea.inventario ? linea.ctaCosto._id : "";
      this.line.ctaImpto = linea.impuesto ? linea.ctaImpto._id : "";
      this.line.vImpuesto = linea.impuesto ? linea.vImpuesto : "";
    },
    saveLine() {
      if (!this.line.codigo) {
        this.error = "La línea creada debe tener un código";
        return false;
      }
      if (!this.line.descripcion) {
        this.error = "La línea creada debe tener una descripción";
        return false;
      }
      if (!this.line.ctaIngreso) {
        this.error = "La línea creada debe tener una cuenta de ingreso";
        return false;
      }
      if (this.line.inventario) {
        if (!this.line.ctaInventario) {
          this.error = "La línea creada debe tener una cuenta de inventario";
          return false;
        }
        if (!this.line.ctaCosto) {
          this.error = "La línea creada debe tener una cuenta de costo";
          return false;
        }
      }
      if (this.line.impuesto) {
        if (!this.line.ctaImpto) {
          this.error = "La línea creada debe tener una cuenta de impuesto";
          return false;
        }
        if (!this.line.vImpuesto) {
          this.error = "La línea creada debe tener un valor en el impuesto";
          return false;
        }
      }
      this.saveLine1();
    },
    async saveLine1() {
      try {
        let result;
        if (this.line._id) {
          result = await apiServices.put(`/editline`, this.line);
        } else {
          result = await apiServices.post(`/createline`, this.line);
        }
        if (result.data.existLine) {
          this.error = "La linea contable ya existe";
        } else {
          if (this.line._id) {
            this.$store.dispatch("notify", {
              message: "Perfecto!. Línea contable editada.",
            });
          } else {
            this.$store.dispatch("notify", {
              message: "Perfecto!. Línea contable creada.",
            });
          }

          this.getLineas(this);
          this.showList();
          this.line = {
            codigo: "",
            descripcion: "",
            impuesto: false,
            ctaIngreso: "",
            inventario: false,
            ctaInventario: "",
            ctaCosto: "",
            ctaImpto: "",
            vImpuesto: "",
          };
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getLineas(this);
  },
  watch: {
    error(nv, ov) {
      if (nv) {
        this.$store.dispatch("notify", {
          message: nv,
          type: "is-warning",
          position: "top-center",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/accountinglines/Accountinglines.vue